import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["prefSelect", "countrySelectArea", "confirmButton", "agreeCheckbox"];
  static classes = ["toggle"];

  connect() {
    window.scroll({ top: 0 });
    this.updateCountryVisibility();
    this.updateConfirmButton();
  }

  updateCountryVisibility() {
    if (this.prefSelectTarget.value == 90) {
      this.countrySelectAreaTarget.classList.remove("is-hide");
    } else {
      this.countrySelectAreaTarget.classList.add("is-hide");
    }
  }

  updateConfirmButton() {
    this.confirmButtonTarget.ariaDisabled = !this.agreeCheckboxTarget.checked;
  }
}
